import React, { ReactNode } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

import { BlogCardContent } from './BlogCardContent';
import { BlogCardImage } from './BlogCardImage';
import { BlogCardContext } from './BlogCardContext';
import { BlogCardType } from './BlogCardType';

export interface BlogCardProps extends DefaultBsComponent {
  hasSubtitleHover?: boolean;
  displaySubtitleOnSmallDevice?: boolean;
  imgPosition?: 'top' | 'bottom' | 'right' | 'left' | 'none';
  hasTransparentBorders?: boolean;
  className?: string;
  onCardClick?: () => void;
  children: ReactNode;
}

export const BlogCardComponent = ({
  hasSubtitleHover = false,
  displaySubtitleOnSmallDevice = false,
  imgPosition,
  hasTransparentBorders = false,
  onCardClick,
  className,
  as: Component = 'div',
  children,
  ...props
}: BlogCardProps) => {
  const shouldSubtitleHover =
    imgPosition === 'none' || imgPosition === 'right' || imgPosition === 'left'
      ? false
      : hasSubtitleHover;

  const handleOnClick = () => {
    if (onCardClick) onCardClick();
  };

  return (
    <BlogCardContext.Provider
      value={{
        onCardClick: handleOnClick,
        displaySubtitleOnSmallDevice,
        hasTransparentBorders,
        imgPosition,
        hasSubtitleHover: shouldSubtitleHover,
      }}
    >
      <Component
        className={classNames(
          'BlogCard',
          'group hover:bg-blue-51 transition duration-300 ease-in-out w-full h-full',
          !imgPosition &&
            'h-auto flex flex-col px-16 sm:px-24 py-24 sm:py-32 border border-neutral-51',
          'overflow-hidden rounded-18',
          ['top', 'bottom'].includes(imgPosition || '') ? 'flex' : 'block',
          !hasTransparentBorders && 'border border-neutral-51',
          onCardClick && 'cursor-pointer hover:shadow-s',
          className,
        )}
        onClick={handleOnClick}
        {...props}
      >
        {children}
      </Component>
    </BlogCardContext.Provider>
  );
};

export const BlogCard = Object.assign(BlogCardComponent, {
  Content: BlogCardContent,
  Image: BlogCardImage,
  Type: BlogCardType,
});
